const maskData = (data, chunkSize = 5, maskChar = '*') => {
  const mask = [];
  const maskCharsPerChunk = data.length / chunkSize;

  for (let i = 0; i < chunkSize / 2; i += 1) {
    mask.push(...' '.repeat(maskCharsPerChunk).split(''));
    mask.push(...maskChar.repeat(maskCharsPerChunk).split(''));
  }

  return data.split('').map((char, index) => (mask[index] === maskChar ? maskChar : char)).join('');
};

module.exports = { maskData };

